import { render } from "./ListeAvisTalents.vue?vue&type=template&id=5a62a688&ts=true"
import script from "./ListeAvisTalents.vue?vue&type=script&lang=ts"
export * from "./ListeAvisTalents.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__